import {
  Load8thwallScripts,
  Do8thwallHitPlane,
  Do8thwallUpdateConfig
} from './arlib/heliodor_8thwall';

let g_AR_APIName = '';

Object.assign(globalThis, {
  // ARの初期化関数
  hel_ar_start: async (settings: any) => {
    g_AR_APIName = settings.apiName;

    if (g_AR_APIName === '8thwall') {
      const result = await Load8thwallScripts(settings);
      if (!result) return false;
    } else if (g_AR_APIName === 'ar.js') {
      // 未実装
    } else {
      return false;
    }

    return true;
  },

  // 平面検出
  hel_ar_hit_plane: (x: number, y: number) => {
    if (g_AR_APIName === '8thwall') {
      return Do8thwallHitPlane(x, y);
    }

    // 8thwall以外は平面検出未対応
    return {
      position: {x: 0.0, y: 0.0, z: 0.0},
      rotation: {x: 0.0, y: 0.0, z: 0.0, w: 0.0},
      distance: 0.0
    };
  },

  // 設定更新
  hel_ar_update_config: (params: string): boolean => {
    const settings = JSON.parse(params);

    if (g_AR_APIName === '8thwall') {
      if (!Do8thwallUpdateConfig(settings)) return false;
    }

    return true;
  }
});
